import { Icon } from '@/components/Icon';
import { Reveal } from '@/components/Reveal';
import { Section } from '@/components/Section';
import { Tag } from '@/components/Tag';
import { caseStudies } from '@/content/site';
import styles from './Work.module.css';

export function Work() {
  return (
    <Section
      id="work"
      eyebrow="selected work"
      title="Systems in production, not slideware"
      lead="Client names are under NDA in most cases. The shape of the problem, the work and the outcome are not."
    >
      <ul className={styles.grid}>
        {caseStudies.map((study, index) => (
          <Reveal as="li" key={study.id} className={styles.card} delay={index * 90}>
            <span className={styles.sector}>{study.sector}</span>
            <h3 className={styles.title}>{study.title}</h3>
            <p className={styles.summary}>{study.summary}</p>

            <div className={styles.tags}>
              {study.engagement.map((item) => (
                <Tag key={item}>{item}</Tag>
              ))}
            </div>

            <p className={styles.metric}>
              <span className={styles.metricValue}>{study.metric.value}</span>
              <span className={styles.metricLabel}>{study.metric.label}</span>
            </p>
          </Reveal>
        ))}
      </ul>

      <Reveal as="p" className={styles.note} delay={120}>
        <Icon name="spark" size={18} />
        Detailed write-ups and references are available on request.
      </Reveal>
    </Section>
  );
}
